import React from "react";
import { Collapse } from "antd";

// A folded group of fields (plan section 6.0), closed at first. The header
// counts the fields in it that differ from their defaults, so a folded
// choice is not forgotten. Flat (11-03): no box around it; the header is one
// text row and the fields continue in the column like the ones above. Every
// fold on the form, Advanced & fee overrides included, is this one kind
// (audit form item 3). `open` / `onToggle` make it controlled.
const Fold = ({ id, title, setCount = 0, open, onToggle, testId, children }) => (
  <Collapse
    ghost
    className={`ppe-fold ppe-fold-${id}`}
    {...(open === undefined ? {} : { activeKey: open ? [id] : [], onChange: () => onToggle && onToggle() })}
    items={[{
      key: id,
      label: (
        <span className="ppe-fold-title" data-testid={testId}>
          {title}
          {setCount > 0 && <span className="ppe-fold-set">{setCount} set</span>}
        </span>
      ),
      children,
    }]}
  />
);

export default Fold;
